const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://lillaflora.nu/api';

export const marketingService = {
  async getAll() {
    const response = await fetch(`${API_BASE_URL}/marketing-pages`);
    if (!response.ok) {
      throw new Error('Failed to fetch marketing pages');
    }
    return response.json();
  },

  async getBySlug(slug) {
    const response = await fetch(`${API_BASE_URL}/marketing-pages/${slug}`);
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error('Failed to fetch marketing page');
    }
    return response.json();
  },

  async create(data) {
    const token = localStorage.getItem('lillaflora_admin_token');
    console.log('Creating marketing page with token:', token ? 'Token exists' : 'No token found');
    console.log('Creating marketing page with data:', {
      title: data.title,
      slug: data.slug,
      contentLength: data.content ? data.content.length : 0,
      hasImage: !!data.featured_image
    });

    const response = await fetch(`${API_BASE_URL}/marketing-pages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    console.log('Marketing page creation response status:', response.status);
    console.log('Marketing page creation response headers:', response.headers);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Marketing page creation failed:', response.status, errorText);
      throw new Error(`Failed to create marketing page: ${response.status} ${errorText}`);
    }
    return response.json();
  },

  async update(id, data) {
    const token = localStorage.getItem('lillaflora_admin_token');
    console.log('Updating marketing page with token:', token ? `Token exists: ${token.substring(0, 20)}...` : 'No token found');
    console.log('Updating marketing page with data:', {
      id,
      title: data.title,
      slug: data.slug,
      contentLength: data.content ? data.content.length : 0,
      hasImage: !!data.featured_image
    });

    const response = await fetch(`${API_BASE_URL}/marketing-pages/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    console.log('Marketing page update response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Marketing page update failed:', response.status, errorText);
      throw new Error(`Failed to update marketing page: ${response.status} ${errorText}`);
    }
    return response.json();
  },

  async delete(id) {
    const token = localStorage.getItem('lillaflora_admin_token');
    const response = await fetch(`${API_BASE_URL}/marketing-pages/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to delete marketing page');
    }
    return true;
  }
};